import api from '../../api/apiSlice';
import { EventType, RawEventType } from './EventType';

type EventTypeUpdateData = Pick<EventType, 'id' | 'name' | 'description' | 'messageTemplate'>;

function parseRawEventType(eventType: RawEventType) {
  return {
    id: eventType.id,
    name: eventType.name,
    description: eventType.description,
    messageTemplate: eventType.message_template,
  };
}

export const eventTypesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listEventTypes: builder.query<EventType[], void>({
      providesTags: ['EventType'],
      query: () => '/event/list',
      transformResponse: (response: RawEventType[]) => response.map(parseRawEventType),
    }),
    detailsEventType: builder.query<EventType, string>({
      providesTags: ['EventType'],
      query: (id) => `/event/${id}`,
      transformResponse: parseRawEventType,
    }),
    updateEventType: builder.mutation<EventType, EventTypeUpdateData>({
      query: ({ id, ...body }) => ({
        url: `/event/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['EventType'],
    }),
  }),
});

export const { useListEventTypesQuery, useDetailsEventTypeQuery, useUpdateEventTypeMutation } = eventTypesApi;
